module.exports = __webpack_public_path__ + "img/c01_unittechballistachampion_Normal_ua.f5768a34.webp";